export const endpoints = {
  path: '/paths',
  pathCategory: '/path/:category',
  pathSubcategories: '/path/subcategories/:category?page=:page',
  pathSubcategory: '/path/:category/:subcategory',
  pathInformation: '/information/:information',
  productTour: '/email/product-tour',
  contact: '/email/contact',
  search: '/search',
}